<template>
  <div class="panel_wrapper panel_wrapper_44">
    <dv-border-box-8 :color="['#227ead', 'rgb(124, 231, 253)']">
      <div class="pad_6 s_title">
        <div class="title_l">用水量监测</div>
        <div class="title_r" />
      </div>
      <div class="lineChart_wrap" ref="lineChartRef">
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="left"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button style="margin-left:20px" size="mini" @click="queryDate" type="primary">
          <span>查询</span>
        </el-button>
         <el-button 
          style="margin-left:20px"
          size="mini"
          @click="exportExcel"
          type="success">
          <span>导出数据</span>
        </el-button>  
        <div id="waterMonitor"></div>
      </div>
    </dv-border-box-8>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waterMonitorData: [
        { time: "1:00", value: 3 },
        { time: "2:00", value: 4 },
        { time: "3:00", value: 3.5 },
        { time: "4:00", value: 5 },
        { time: "5:00", value: 4.9 },
        { time: "6:00", value: 6 },
        { time: "7:00", value: 7 },
        { time: "8:00", value: 9 },
        { time: "9:00", value: 13 }
      ],
      pieChart: undefined,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      dateValue: []
    };
  },
  mounted() {},
  created(){
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
    end.setTime(end.getTime() - 3600 * 1000 * 24);
    //const end = new Date();
    //end.setTime(end.getTime() - 3600 * 1000 * 24);
    this.dateValue = [start,end];
  },
  methods: {
    queryDate() {
      console.log(this.dateValue);
      this.getData();
    },
    dataToStr(date) {
      var year = date.getFullYear(); //年
      var month = date.getMonth()+1; //月
      var day = date.getDate(); //日
      if(month < 10){
        month = '0'+month;
      }
      if(day < 10){
        day = '0'+day;
      }
      return year + "-" + month + "-" + day;
    },
    getData() {
      var that = this;
      this.$post("/apis/manage/home/getSbData", {
        token: sessionStorage.getItem("token"),
        placeid: sessionStorage.getItem("selectPlace"),
        startTime: this.dataToStr(this.dateValue[0]),
        endTime: this.dataToStr(this.dateValue[1])
      })
        .then(function(res) {
          if (res.errno == 0) {
            var data = res.data;
            var newData = [];
            for(var i=0;i<data.length;i++){
              newData.push({
                time:data[i].time,
                value:parseFloat(data[i].value)
              })
            }
            that.waterMonitorData = newData;
            that.showData();
          }
        })
        .catch(function(err) {
          window.console.log(err);
        });
    },
    // 导出excel格式
    exportExcel() {
      // 树结构转一维数组
      let arr = this.waterMonitorData
      console.log(arr);
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/excel/Export2Excel')
        const tHeader = ['日期', '流量(m³)']
        const filterVal = ['time', 'value'];
        const list = arr
        const data = this.formatJson(filterVal, list)
        console.log('data');
        console.log(data);
        var title = sessionStorage.getItem("companyName") + '('+sessionStorage.getItem("selectPlaceName") +')';
        var startTime = this.dataToStr(this.dateValue[0])
        var endTime = this.dataToStr(this.dateValue[1])
        if(startTime == endTime){
          title += ('_'+startTime);
        }else{
          title += ('_'+startTime+'~'+endTime);
        }
        title += '流量数据'
        export_json_to_excel(tHeader, data, title)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    showData() {
      const pieChartHeight = this.$refs.lineChartRef.offsetHeight;
      if (this.pieChart == undefined) {
        console.log(54444);
        this.pieChart = new G2.Chart({
          container: "waterMonitor",
          forceFit: true,
          height: pieChartHeight,
          padding: [50, 20, 50, 40]
        });
      }
      this.pieChart.clear();
      this.pieChart.source(this.waterMonitorData);
      this.pieChart.scale("value", {
        // 度量
        min: 0 // Y轴显示的最小值
      });
      this.pieChart.scale("time", {
        // 度量
        range: [0, 1] // 数值范围区间
      });
      this.pieChart.tooltip({
        // 提示信息
        crosshairs: {
          type: "line" // 提示信息类型
        },
        itemTpl: '<li><span>流量: {value}(m³)</span></li>'
      });
      this.pieChart.line().position("time*value"); // 几何标记类型   线，  position:二维坐标系内设至 x轴 y轴
      this.pieChart
        .point()
        .position("time*value")
        .size(4)
        .shape("circle")
        .style({
          // 几何标记类型   点，  二维坐标系内设置 x轴 y轴    大小   图形形状
          stroke: "#fff",
          lineWidth: 1
        });
      this.pieChart.render(); // 渲染
    }
  }
};
</script>

<style lang="less" scoped>
.s_title {
  width: 100%;
  height: 48px;
  display: flex;
  .title_l {
    line-height: 30px;
    flex: 1;
    border-radius: 2px;
    font-size: 18px;
    text-align: center;
    color: rgb(143, 185, 196);
    box-shadow: 0px 0px 21px rgb(152, 175, 182) inset;
  }
  .title_r {
    padding-top: 8px;
    flex: 3;
    display: flex;
    justify-content: space-around;
  }
}
.lineChart_wrap {
  width: 98%;
  height: calc(100% - 60px);
  margin: 0 auto;
  // 日期选择器
  /deep/.el-input__inner {
    background: 000;
    border: 1px solid #227ead;
    border-radius: 6px;
    color: #adadad;
  }
  /deep/.el-range-input {
    background-color: #133049;
    color: #dedede;
  }
  /deep/.el-range-separator {
    color: #dedede;
  }
  /deep/.el-picker-panel__sidebar {
    background-color: #133049;
  }
}
</style>